import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import { crmUi } from "./CrmUi";

const MiniLineChart = () => (
  <Box sx={{ mt: 1 }}>
    <svg viewBox="0 0 520 185" width="100%" height="185" preserveAspectRatio="none">
      {[30, 70, 110, 150].map(y => (
        <line key={y} x1="0" x2="520" y1={y} y2={y} stroke="#eef0f3" strokeWidth="1" />
      ))}
      <path
        d="M0,145 C50,140 65,125 110,130 C155,120 180,95 220,102 C260,95 285,72 330,82 C380,90 400,58 445,68 C475,58 500,48 520,35"
        fill="none"
        stroke="#d92d20"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M0,158 C45,152 85,148 110,143 C155,132 190,140 220,123 C260,114 300,118 330,103 C370,92 410,96 445,85 C475,76 500,65 520,58"
        fill="none"
        stroke="#4c78b8"
        strokeWidth="2.3"
        strokeLinecap="round"
      />
      {[0,110,220,330,445,520].map((x, i) => (
        <circle key={x} cx={x} cy={[145,130,102,82,68,35][i]} r="3.5" fill="#d92d20" />
      ))}
    </svg>

    <Stack direction="row" justifyContent="space-between" sx={{ mt: -0.4 }}>
      {["13 maj", "27 maj", "10 jun", "24 jun"].map(x => (
        <Typography key={x} sx={{ color: crmUi.subtle, fontSize: 9.5 }}>{x}</Typography>
      ))}
    </Stack>
  </Box>
);

export default MiniLineChart;
